var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.89 13.7H0v-3.112h24.89z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.443 12.507 15.45 24.5l-2.2-2.2 11.995-11.994z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.248 13.7-11-11 2.2-2.2 11 11z"
}))));
export default SvgArrowRight;